import httpClient from '@/api/http-client';

const endpoint = 'api/system-log-files';

const systemLogFilesService = {
  getFiles: (params) => httpClient.get(endpoint, { params }),

  downloadFile: (file) =>
    httpClient({
      url: `${endpoint}/${file.name}`,
      method: 'GET',
      responseType: 'blob',
    }),
};

export default systemLogFilesService;
